import { jsx as _jsx } from 'react/jsx-runtime.js';
import { AppleButtonComponent } from './AppleButtonComponent.js';
import { useOptimizelyExperiment } from '../../optimizely/useOptimizelyExperiment.js';
import { AppleLoginExperimentKey } from '../../optimizely/allExperiments/appleLogin.js';
export const AppleButton = () => {
    // after cleaning the test we should use isAppleEnabledSelector to display the Apple button
    // also the brands.tsx update is required to set socialButtons.apple to true for the brands that support Apple login
    const appleLoginExperimentVariant = useOptimizelyExperiment(AppleLoginExperimentKey);
    return appleLoginExperimentVariant === 'B' ? _jsx(AppleButtonComponent, {}) : null;
};
//# sourceMappingURL=AppleButton.js.map